// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1642":"0e50a2b32d2d64b50afa","5706":"3153330af47fc26a725a","6127":"f0d0bf8b1ad724c3254b"}[chunkId] + "";
};